export default class MobileAccordion {
    constructor() {
        this.accordion = document.querySelector('.js-mobile-accordion');
        this.accordionBody = null;
        if (!this.accordion) {
            console.error('Mobile accordion not found');
            return;
        }

        this.setBodyHeight = this.setBodyHeight.bind(this);
        this.setBodyDefaultState = this.setBodyDefaultState.bind(this);
        this.bindEvents = this.bindEvents.bind(this);
        this.openAccordion = this.openAccordion.bind(this);
        this.closeAccordion = this.closeAccordion.bind(this);
        this.init = this.init.bind(this);

        this.init();
    }

    waitForElement(query, timeout = 10000) {
        return new Promise((resolve, reject) => {
            const startTime = Date.now();
            const tryQuery = () => {
                const elem = document.querySelector(query);
                if (elem) resolve(elem); // Found the element
                else if (Date.now() - startTime > timeout) resolve(null); // Give up eventually
                else setTimeout(tryQuery, 10); // check again every 10ms
            };
            tryQuery(); // Initial check
        });
    }

    setBodyDefaultState() {}

    setBodyHeight() {
        this.accordionBody = document.querySelector('.js-mobile-accordion-body');
        this.accordionBody.dataset.height = this.accordionBody.offsetHeight + 'px';
    }

    openAccordion() {
        this.accordionBody.style.display = 'flex';
        this.accordion.querySelector('img').style = 'transform: rotate(180deg)';
        this.accordion.classList.add('active');
    }

    closeAccordion() {
        this.accordionBody.removeAttribute('style');
        this.accordion.querySelector('img').style = 'transform: rotate(0deg)';
        this.accordion.classList.remove('active');
    }

    bindEvents() {
        this.accordion.addEventListener('click', () => {
            if (!this.accordion.classList.contains('active')) {
                this.openAccordion();
            } else {
                this.closeAccordion();
            }
        });
    }

    async init() {
        const body = await this.waitForElement('.js-mobile-accordion-body');
        if (!body) return;
        this.accordionBody = body;
        if (window.innerWidth < 1024) this.setBodyDefaultState();
        this.bindEvents();
    }
}

if (document.querySelector('.js-mobile-accordion')) new MobileAccordion();
